import { createSlice } from "@reduxjs/toolkit";

// ✅ Helper: Load cart safely from localStorage
const loadCartFromLocalStorage = () => {
  try {
    const serialized = localStorage.getItem("cart");
    if (!serialized) return [];

    const parsed = JSON.parse(serialized);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.error("Failed to parse cart from localStorage:", err);
    return [];
  }
};

const initialState = {
  cart: loadCartFromLocalStorage(),
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addProduct: (state, action) => {
      const incoming = action.payload;

      const itemToAdd = {
        ...incoming,
        Qunatity: Number(incoming.Qunatity) || 1,
      };

      const existingIndex = state.cart.findIndex(
        (item) =>
          item.product_id === itemToAdd.product_id &&
          item.variant === itemToAdd.variant
      );

      if (existingIndex !== -1) {
        state.cart[existingIndex].Qunatity += itemToAdd.Qunatity;
      } else {
        state.cart.push(itemToAdd);
      }
    },

    updateQuantity: (state, action) => {
      const { id, variant, quantity } = action.payload;

      const targetIndex = state.cart.findIndex(
        (item) => item.product_id === id && item.variant === variant
      );

      if (targetIndex === -1) return;

      const newQty = Number(quantity);

      if (newQty <= 0) {
        state.cart.splice(targetIndex, 1);
      } else {
        state.cart[targetIndex].Qunatity = newQty;
      }
    },

    removeProduct: (state, action) => {
      const { id, variant } = action.payload;

      state.cart = state.cart.filter(
        (item) => !(item.product_id === id && item.variant === variant)
      );
    },

    clearCart: (state) => {
      state.cart = [];
    },
  },
});

export const { addProduct, updateQuantity, removeProduct, clearCart } =
  cartSlice.actions;

export default cartSlice.reducer;

export const syncCartWithLocalStorage = (store) => (next) => (action) => {
  const result = next(action);

  // ✅ only run for cart actions
  if (action.type.startsWith("cart/")) {
    const currentCart = store.getState().cart.cart;

    try {
      localStorage.setItem("cart", JSON.stringify(currentCart));
    } catch (err) {
      console.error("Failed to save cart to localStorage:", err);
    }
  }

  return result;
};
